import SchoolSearch from '../lib/school-search.js';
import isAndroid from '../lib/isAndroid.js';
import getAndVer from '../lib/getAndVer.js';

export default () => {
  const { protocol, host } = location;
  $(function () {
    if(!isAndroid() || getAndVer() > 4) {
      new SchoolSearch(
        `https://exam.nucba.ac.jp/net/api/school/code.json`,
        '.js-school-search',
        '.js-school-list',
        '.js-school-result',
        '.js-school-other'
      );
    }
  });
}
